import { render, staticRenderFns } from "./BotaoDenuncia.vue?vue&type=template&id=db1b7d6a&lang=pug"
import script from "./BotaoDenuncia.vue?vue&type=script&lang=js"
export * from "./BotaoDenuncia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports